var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReviewsList',{attrs:{"avgRating":_vm.avgRating,"reviews":_vm.transformedReviews,"isLoading":_vm.$apollo.loading,"canShowMore":_vm.canShowMore},on:{"show-more":_vm.showMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }